import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ErrorToastService, ErrorContentDto } from '@uoa/error-pages';
import { ErrorToastComponent } from '../../shared/components/errorMsg/error-toast.component';
@Injectable({
  providedIn: 'root',
})
export class AppToastService implements ErrorToastService {
  private readonly modalCtrl = inject(ModalController);

  createToast(content: ErrorContentDto): void {
    /**
     * The createToast function on the abstract class is not asynchronous so
     * we cannot change the method signature, but must implement the asynchronous use of the ionic toast
     * using an immediately executing function.
     */
    (async () => {
      
      const modal = await this.modalCtrl.create({
        component: ErrorToastComponent,
        componentProps: {
          title: content.title,
          html: content.content, // full HTML preserved
        },
        cssClass: 'toast-modal',
        showBackdrop: false,
        backdropDismiss: false,
        animated: true,
      });

        await modal.present();
    })();

      
  }
}
